import type { CityConfig } from "@/pages/city-template/types";

export const scottsdaleConfig: CityConfig = {
  city: "Scottsdale",
  state: "Arizona",
  stateAbbr: "AZ",
  slug: "scottsdale",
  route: "/cities/scottsdale",
  title: "Emergency Passport Scottsdale, AZ — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Scottsdale, AZ — as fast as 24 hours. Reserved courier processing for Mayo Clinic physicians, Barrett-Jackson collectors, resort executives, and Scottsdale residents. A+ BBB rated, registered State Dept. courier. No LA agency drive required.",
  keywords: "Scottsdale passport, expedited passport Scottsdale AZ, emergency passport Scottsdale, fast passport Scottsdale, passport renewal Scottsdale, Scottsdale passport courier, urgent passport Arizona, same day passport Scottsdale, Mayo Clinic passport, Barrett-Jackson passport",
  h1: "Emergency & Expedited Passport Services in Scottsdale, AZ",
  heroSubtitle: "Last-minute luxury resort trip to Cabo? Mayo Clinic Scottsdale physician heading to a medical conference in Europe? HonorHealth executive with a Tokyo business trip booked next week? Barrett-Jackson car collector traveling to international auctions? We help Scottsdale residents — from the Biltmore corridor to North Scottsdale estates to Gainey Ranch — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Scottsdale%20Arizona%20downtown%20skyline%20at%20golden%20hour%20with%20McDowell%20Mountains%20in%20background%2C%20luxury%20resort%20hotels%20and%20palm%20tree%20lined%20streets%20visible%2C%20desert%20landscape%20with%20warm%20amber%20sunset%20tones%2C%20Camelback%20Mountain%20silhouette%20on%20the%20horizon%2C%20modern%20upscale%20architecture%20in%20the%20Arizona%20desert%2C%20cinematic%20drone%20photography%20with%20rich%20warm%20colors%20and%20dramatic%20light&width=1800&height=700&seq=scottsdale-hero-az&orientation=landscape",
  heroImageAlt: "Scottsdale Arizona skyline with McDowell Mountains at sunset",
  geoPosition: "33.4942;-111.9261",
  geoPlacename: "Scottsdale, Arizona",
  lastModified: "2026-07-18",
  regionalAgency: {
    name: "Los Angeles Passport Agency",
    address: "11000 Wilshire Blvd, Los Angeles, CA 90024",
    distance: "Approximately 370 miles — about 5.5 hours via I-10 West. The nearest passport agency to Scottsdale and the Northeast Phoenix metro.",
  },
  nearbyCitiesZips: [
    { name: "Scottsdale", zips: "85250, 85251, 85254, 85255, 85257, 85258, 85259, 85260, 85262, 85266, 85268" },
    { name: "Paradise Valley", zips: "85253" },
    { name: "Fountain Hills", zips: "85268" },
    { name: "Cave Creek / Carefree", zips: "85331, 85377" },
    { name: "Tempe / Mesa East", zips: "85281, 85282, 85283" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your Scottsdale home, North Scottsdale estate, or Gainey Ranch office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping to send your documents directly to us from any UPS or FedEx location — we handle every detail from there.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent costly delays for your resort trip or business travel.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed. No driving to Los Angeles.",
    },
  ],
  officePhone: "(877) 253-0084",
  officeHours: [
    { days: "Monday–Friday", hours: "9:00 AM – 6:00 PM EST" },
    { days: "Saturday", hours: "10:00 AM – 2:00 PM EST" },
    { days: "Sunday", hours: "Closed" },
  ],
  officePhotoUrl: "https://storage.readdy.site.link/project_files/5b15eb5b-af79-4c03-9ad0-73c6095d69a7/39b34e24-6cae-4aa4-bcd8-dc68c850858b_compressed_phoenix-az---office.webp",
  officePhotoAlt: "Fast Passport Center office building in Phoenix, Arizona — modern multi-story glass and stone professional building at 4742 N 24th St in the Camelback East corridor",
  landmarks: [
    { name: "Camelback Mountain", distance: "Scottsdale/Paradise Valley border", icon: "ri-landscape-line", desc: "Iconic mountain landmark visible throughout Scottsdale" },
    { name: "Old Town Scottsdale", distance: "Downtown", icon: "ri-store-2-line", desc: "Historic arts, shopping, and dining district" },
    { name: "Mayo Clinic Scottsdale", distance: "North Scottsdale", icon: "ri-heart-pulse-line", desc: "World-renowned medical campus on E Shea Blvd" },
    { name: "TPC Scottsdale", distance: "North Scottsdale", icon: "ri-golf-ball-line", desc: "Host of the PGA Tour Waste Management Phoenix Open" },
    { name: "WestWorld / Barrett-Jackson", distance: "North Scottsdale", icon: "ri-car-line", desc: "Annual collector car auction drawing global attendees" },
    { name: "Scottsdale Airport (SDL)", distance: "~9 miles from Old Town", icon: "ri-flight-takeoff-line", desc: "Major private aviation and executive charter hub" },
    { name: "Taliesin West", distance: "Northeast Scottsdale", icon: "ri-building-line", desc: "Frank Lloyd Wright's winter home and architecture school" },
    { name: "McDowell Sonoran Preserve", distance: "North Scottsdale", icon: "ri-landscape-line", desc: "30,000+ acres of protected desert landscape and trails" },
  ],
  exploreNearbyHeading: "Scottsdale Landmarks & Nearby Destinations",
  internalLinks: [
    { name: "Emergency passport in Phoenix AZ", route: "/cities/phoenix" },
    { name: "Expedited passport in Mesa AZ", route: "/cities/mesa" },
    { name: "Urgent passport in Chandler AZ", route: "/cities/chandler" },
    { name: "Fast passport in Gilbert AZ", route: "/cities/gilbert" },
    { name: "Expedited passport in Paradise Valley AZ", route: "/cities/paradise-valley" },
    { name: "Emergency passport in Peoria AZ", route: "/cities/peoria-az" },
    { name: "Arizona passport hub", route: "/states/arizona" },
    { name: "Expedited passport in Tempe AZ", route: "/cities/tempe" },
  ],
  fpcOfficeAddress: "4742 N 24th St, Phoenix, AZ 85016",
  fpcOfficeNote: "Fast Passport Center serves Scottsdale remotely via secure courier. After signing up online, ship your documents overnight from any UPS or FedEx location in Scottsdale. Most clients ship from home — no office visit required. The nearest passport agency (Los Angeles) is over 370 miles away. We eliminate that trip entirely through reserved courier submission.",
  fpcOfficeDistance: "Serving all of the Northeast Phoenix Metro",
  areaServedList: [
    { "@type": "City", name: "Scottsdale" },
    { "@type": "City", name: "Paradise Valley" },
    { "@type": "City", name: "Fountain Hills" },
    { "@type": "City", name: "Cave Creek" },
    { "@type": "City", name: "Carefree" },
    { "@type": "City", name: "Tempe" },
    { "@type": "City", name: "Mesa" },
    { "@type": "City", name: "Phoenix (Northeast)" },
    { "@type": "AdministrativeArea", name: "Maricopa County" },
  ],
  serviceAreaDesc: "Fast Passport Center serves Scottsdale remotely via secure courier from our Phoenix office at 4742 N 24th St. A+ BBB rated registered U.S. Department of State passport courier providing emergency and expedited passport services as fast as 24 hours to Scottsdale, Paradise Valley, Fountain Hills, Cave Creek, Carefree, and the entire Northeast Phoenix metro region.",
  serviceAreaIntro: "Scottsdale occupies a unique position in the American travel landscape. It is simultaneously a world-class resort destination and a sophisticated business hub — home to the Mayo Clinic campus, the headquarters of major financial and insurance firms, a thriving biotech corridor along Scottsdale Road, and one of the most affluent retirement communities in the American Southwest. The result is a traveler base with high standards, disposable income, and very little patience for bureaucratic delays.",
  nearbyCitiesIntro: "We serve Scottsdale and nearby communities including Paradise Valley, Fountain Hills, Cave Creek, Carefree, Tempe, Mesa, and the entire Northeast Phoenix metro region.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Scottsdale as simple as possible — with the efficiency and reliability that Mayo Clinic physicians, Barrett-Jackson collectors, and North Scottsdale executives expect. Because we are a registered U.S. Department of State courier (not a reseller), we pass those savings directly to you with our best price guarantee.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Scottsdale travelers. Fast Passport Center reviews your documents before submission to catch these issues — so your luxury resort trip, medical conference, or automotive auction stay on schedule.",
  testimonialsIntro: "Real reviews from Mayo Clinic physicians, automotive collectors, and Scottsdale professionals who trusted Fast Passport Center with their expedited passports.",
  faqIntro: "Everything Scottsdale and Northeast Phoenix metro travelers ask us most often about expedited passport services.",
  localAreaIntro: [
    "The luxury resort and hospitality industry drives substantial last-minute international travel demand. Executives staying at the Four Seasons Troon North, Fairmont Scottsdale Princess, or The Boulders book business trips and spa retreats on compressed timelines. International clients arrive for automotive auctions at Barrett-Jackson, PGA Tour events at TPC Scottsdale, and Waste Management Phoenix Open hospitality. These travelers book quickly — and discover passport issues just as fast.",
    "The biomedical and healthcare corridor adds another urgent travel segment. Mayo Clinic physicians travel to international medical conferences and research symposia with publication deadlines that do not move. HonorHealth and Scottsdale Healthcare specialists attend CME programs in Europe and Asia. Biotech executives at the SkySong innovation campus fly to international partner meetings and regulatory submissions. For these professionals, a passport problem is not merely inconvenient — it represents a career obligation missed.",
    "Fast Passport Center serves all of these Scottsdale traveler profiles with the same expedited, professional service: dedicated agents, document review before submission, reserved agency access, and processing as fast as 24 hours. The nearest passport agency is the Los Angeles Passport Agency — over 370 miles from Scottsdale via I-10. Our courier service eliminates that journey entirely, delivering predictable results for even the most time-sensitive Scottsdale travel plans.",
  ],
  statePageRoute: "/states/arizona",
  statePageName: "Arizona",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Service Area", href: "#service-area" },
    { label: "Services", href: "#services" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
      emergencyDescription: "Arizona has only 1 passport agency (Tucson, ~115 miles via I-10, 1.75+ hours). The entire Phoenix metro area — 5+ million people — relies on this single Tucson agency for emergency passport services. Summer temperatures regularly exceed 110°F, making the I-10 desert drive genuinely dangerous with elevated risk of vehicle breakdowns and heat-related emergencies. Monsoon season (July–September) brings flash floods that can close I-10 between Phoenix and Tucson for hours or days. The Tucson agency's limited appointment capacity cannot meet Phoenix metro demand — weeks-long waitlists are standard during peak travel seasons.",
    },
  ],
  processingIntro: "Scottsdale travelers — resort executives, Mayo Clinic physicians, biotech professionals, and Northeast Valley families — have several passport options. Here is how they compare, and why most Scottsdale residents choose a registered State Department courier rather than driving 115 miles to Tucson for an emergency passport agency appointment.",
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Luxury resort trip to Cabo or Mexico booked next week? Barrett-Jackson collector heading to an international auction? Mayo Clinic physician with a last-minute medical conference in Europe? Our emergency courier service prioritizes your application — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Scottsdale residents renew fast — no agency visit required for most renewals. Perfect for North Scottsdale executives, Gainey Ranch retirees, and biotech professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants typically require an in-person acceptance clerk visit. We guide you through every step, with clear instructions for Scottsdale and McCormick Ranch residents — so your resort trip or international business meeting stays on track.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements often require additional forms. We guide you through exactly what is needed to avoid costly mistakes and delays — so your Scottsdale resort vacation or HonorHealth medical travel is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors (15 and under) require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Scottsdale family vacation to Mexico or Europe stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations and hotel bookings for your next international resort trip.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Scottsdale executives, investment professionals, and car collectors who cross borders regularly for business.",
      bullets: ["Frequent traveler solutions", "Valid alongside existing passport", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged or water-damaged passport? We guide Scottsdale travelers through the replacement process with clear instructions.",
      bullets: ["Damaged passport replacement", "Documentation guidance", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesIntro: "Whether you need a renewal before a business trip to Tokyo, a first-time passport for a luxury resort in Mexico, or an emergency replacement for a medical conference in Europe — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  servicesSchema: [
    { name: "Emergency Passport Scottsdale AZ", description: "Urgent passport processing for Scottsdale, AZ travelers via registered State Department courier — as fast as 24 hours." },
    { name: "Passport Renewal Scottsdale AZ", description: "Fast passport renewal for Scottsdale, Northeast Phoenix metro, and Paradise Valley, Arizona residents." },
    { name: "New Passport Scottsdale AZ", description: "First-time passport application assistance for Scottsdale, McCormick Ranch, and Northeast Valley residents." },
    { name: "Lost Passport Scottsdale AZ", description: "Passport replacement for lost or stolen passports for Scottsdale and Northeast Phoenix metro residents." },
    { name: "Child Passport Scottsdale AZ", description: "Minor passport services for Scottsdale and Northeast Valley families." },
    { name: "Name Change Passport Scottsdale AZ", description: "Passport name change service for Scottsdale, AZ residents after marriage, divorce, or legal changes." },
    { name: "Second Passport Scottsdale AZ", description: "Second passport services for Scottsdale executives and frequent international travelers." },
    { name: "Damaged Passport Scottsdale AZ", description: "Damaged passport replacement for Scottsdale and Northeast Phoenix metro residents." },
    { name: "Passport Card Scottsdale AZ", description: "U.S. Passport Card services for Scottsdale, AZ residents — wallet-size for land and sea border crossings." },
  ],
  testimonials: [
    {
      name: "Dr. Patricia L.",
      location: "North Scottsdale / Mayo Clinic",
      rating: 5,
      text: "I had a research symposium presentation in Stockholm with 11 days notice and my passport was expired — it had lapsed during the pandemic when I was not traveling internationally. Fast Passport Center reviewed my renewal documents the same day I contacted them, submitted through their courier access, and I had my passport in seven business days. Made my flight from PHX without any issue. Absolutely indispensable for physician travelers.",
      service: "Expedited Renewal",
    },
    {
      name: "Robert K.",
      location: "DC Ranch, Scottsdale",
      rating: 5,
      text: "I collect classic and exotic cars and attend international auctions, including Concours events in France and England. I discovered my passport expired three weeks before a Goodwood event I had been planning for months. Fast Passport Center handled everything remotely — I shipped overnight from my home in DC Ranch and had a fresh passport back in five business days. Genuinely the only service I would trust for a time-sensitive situation like this.",
      service: "Passport Renewal",
    },
    {
      name: "Amelia & James T.",
      location: "Gainey Ranch, Scottsdale",
      rating: 5,
      text: "We booked a last-minute Mediterranean cruise as an anniversary gift to ourselves and immediately realized our adult daughter traveling with us had an expired passport. We found Fast Passport Center online, contacted them Monday morning, shipped the application Monday afternoon, and she had her renewed passport Thursday. We were on the ship the following Tuesday. The whole experience was professional, fast, and incredibly low-stress given the timeline.",
      service: "Emergency Renewal",
    },
  ],
  facilities: [
    {
      id: "sdl-1",
      name: "Scottsdale Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7225 N Pima Road",
      city: "Scottsdale",
      state: "AZ",
      zip: "85258",
      phone: "(480) 596-2828",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Scottsdale",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary passport acceptance facility for Scottsdale and North Scottsdale. Appointment required. Photo services available on-site. Book well in advance during spring travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "sdl-2",
      name: "Scottsdale Old Town Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7300 E Shoeman Ln",
      city: "Scottsdale",
      state: "AZ",
      zip: "85251",
      phone: "(480) 941-9770",
      hours: "Mon–Fri: 8:30 AM – 5:00 PM",
      distance: "Old Town Scottsdale",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Arcadia, Old Town Scottsdale, and Tempe border residents. Call ahead to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "sdl-3",
      name: "Paradise Valley Town Hall",
      type: "Municipal Passport Acceptance Facility",
      address: "6401 E Lincoln Drive",
      city: "Paradise Valley",
      state: "AZ",
      zip: "85253",
      phone: "(480) 348-3600",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Paradise Valley — adjacent to Scottsdale",
      website: "https://www.paradisevalleyaz.gov/",
      websiteLabel: "Paradise Valley Official Site",
      notes: "Passport acceptance services available for Paradise Valley residents. Appointment highly recommended. Limited capacity — fills quickly during peak travel months.",
      icon: "ri-government-line",
    },
    {
      id: "sdl-4",
      name: "Fountain Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11445 N Saguaro Blvd",
      city: "Fountain Hills",
      state: "AZ",
      zip: "85268",
      phone: "(480) 837-2004",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fountain Hills — northeast of Scottsdale",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fountain Hills and McDowell Mountain Ranch residents. Call ahead for current passport appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited availability, often weeks out", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to LA Passport Agency (~370 mi)", fpc: "Most travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review to reduce delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable", fpc: "Predictable processing based on option selected" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documents" },
    { feature: "Cost vs Resellers", agency: "Not applicable", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Direct State Dept. Access", agency: "Not available to the public", fpc: "Registered courier — not a middleman or reseller" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Apply",
      description: "Government processing times change constantly. Many Scottsdale travelers assume 6–8 weeks is safe, only to find out it is now 3–4 months. When your Mayo Clinic conference, Barrett-Jackson auction, or luxury resort trip has a fixed date, apply as soon as you confirm travel.",
    },
    {
      icon: "ri-camera-off-line",
      title: "Wrong Passport Photo",
      description: "Photos from hotel business centers and retail stores often get rejected for lighting, background, or expression issues. We provide exact specs so you get it right the first time — because a rejected photo can derail a time-sensitive medical conference or collector event.",
    },
    {
      icon: "ri-file-damage-line",
      title: "Incomplete Forms",
      description: "One missing signature or wrong date and your application gets sent back. Our checklist catches errors before submission, saving you weeks of delay that you simply do not have before an international conference or auction.",
    },
    {
      icon: "ri-pen-nib-line",
      title: "Wrong Proof of Citizenship",
      description: "Not all birth certificates are accepted. Some require a long-form version. We tell you exactly which documents you need based on your situation — so your Scottsdale business travel or resort vacation is not delayed.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Missing Travel Proof for Emergency",
      description: "Regional agencies require documented proof of urgent travel. Without it, you are turned away. We help you prepare the right documentation before you need it — essential for last-minute executive travel and medical conference appearances.",
    },
    {
      icon: "ri-map-pin-time-line",
      title: "Not Checking Name Consistency",
      description: "Your passport name must match your airline ticket and hotel reservation exactly. Hyphenated names, suffixes, and middle names cause more rejections than you would expect — especially for frequent travelers maintaining multiple booking profiles.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-computer-line",
      title: "Start Your Order Online",
      description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your Scottsdale home, North Scottsdale office, or DC Ranch estate.",
    },
    {
      number: "02",
      icon: "ri-file-list-3-line",
      title: "We Confirm & Send Your Checklist",
      description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your specific travel situation.",
    },
    {
      number: "03",
      icon: "ri-send-plane-line",
      title: "Ship Your Documents Overnight",
      description: "Send your documents using an overnight shipping option from any UPS or FedEx location in Scottsdale. Most clients ship from home — no office visit needed.",
    },
    {
      number: "04",
      icon: "ri-building-2-line",
      title: "We Submit Through Reserved Access",
      description: "We submit through our reserved passport agency availability — so you do not have to drive 370 miles to Los Angeles or wait at a passport agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Your Passport Is Completed",
      description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty before your resort trip or conference.",
    },
  ],
  faqs: [
    {
      q: "How fast can I get a passport in Scottsdale, AZ?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office in Scottsdale can take 2–6 months, especially during peak travel seasons. For Mayo Clinic physicians, Barrett-Jackson collectors, and resort executives on tight timelines, that simply is not viable.",
    },
    {
      q: "Do I need to drive to Los Angeles to get an emergency passport from Scottsdale?",
      a: "No — that is exactly why Fast Passport Center exists. The nearest regional passport agency to Scottsdale is the Los Angeles Passport Agency, about 370 miles away via I-10 West. Getting an appointment there is unpredictable and requires taking an entire day or more. Fast Passport Center eliminates that trip entirely through reserved courier submission. You start online, ship your documents overnight, and we handle the rest.",
    },
    {
      q: "Can Mayo Clinic or HonorHealth physicians get a passport fast for an international conference?",
      a: "Absolutely. Medical professionals traveling to international conferences and CME programs are one of our most common Scottsdale client types. Conference schedules are fixed and non-negotiable. We regularly process expedited renewals and replacements for Scottsdale-area physicians with 5–14 day lead times before major international medical meetings in Europe and Asia.",
    },
    {
      q: "I attend the Barrett-Jackson auction and travel internationally for collector events. How can I get a passport renewed quickly?",
      a: "Collector car travel — to Concours d'Elegance events in France, Goodwood in England, Japanese classic car events — often requires current passports on short notice. We handle expedited renewals for Scottsdale automotive collectors regularly. Start your order online, ship your documents overnight from home, and we handle the rest through reserved agency submission.",
    },
    {
      q: "Can Scottsdale residents get a child's passport fast for a Mexico resort trip?",
      a: "Yes. Child passports (for minors 15 and under) require an in-person acceptance clerk step and consent from both parents. We provide a clear, step-by-step checklist for Scottsdale families so the process is straightforward. Most Mexico resort destinations — especially Los Cabos and Puerto Vallarta — require passports for all passengers, including children, for any air travel.",
    },
    {
      q: "How do I get a passport photo in Scottsdale before applying?",
      a: "Passport photos are available at CVS, Walgreens, FedEx Office, The UPS Store, and other locations throughout Scottsdale and North Scottsdale. Your photo must meet strict U.S. State Department specifications — neutral expression, white or off-white background, no glasses. We provide exact requirements so you get it right the first time and avoid rejection.",
    },
    {
      q: "What if my Scottsdale trip to Mexico is next week and my passport just expired?",
      a: "This is one of the most common situations we handle. If your Mexico trip is within the next 2 weeks, start your order immediately. For most Scottsdale renewal applicants, we can complete expedited processing in 2–9 business days depending on the option selected. In genuine emergencies with documented travel within 3 days, we have fastest available options. Contact us as soon as possible — every day matters.",
    },
    {
      q: "Do I need to visit a Fast Passport Center office in Scottsdale?",
      a: "No — there is no local Fast Passport Center office in Scottsdale, and you do not need one. Start your order online from your Scottsdale home or office, follow the personalized checklist we send you, and ship your documents overnight from any UPS or FedEx location in the area. We handle all agency submission remotely through our reserved courier access.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability — at lower cost than resellers like FedEx or Staples.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — N Scottsdale Rd", address: "7720 N Scottsdale Rd, Scottsdale, AZ 85253", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — E Shea Blvd", address: "7250 E Shea Blvd, Scottsdale, AZ 85260", hours: "Call for hours" },
    { name: "FedEx Office — N Scottsdale Rd", address: "15169 N Scottsdale Rd, Scottsdale, AZ 85254", hours: "Call for hours" },
    { name: "The UPS Store — Old Town Scottsdale", address: "4222 N Marshall Way, Scottsdale, AZ 85251", hours: "Call for hours" },
    { name: "CVS Pharmacy — E McDowell Rd", address: "5660 E McDowell Rd, Scottsdale, AZ 85257", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — N Pima Rd", address: "15670 N Pima Rd, Scottsdale, AZ 85260", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Scottsdale MVD Office",
      address: "8057 E Thomas Rd, Scottsdale, AZ 85251",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      note: "Primary Scottsdale MVD location. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Paradise Valley MVD",
      address: "Scottsdale area — use ServiceArizona.com for nearest location",
      hours: "Varies by location",
      note: "Check ServiceArizona.com for the most current hours and locations.",
      featured: false,
    },
  ],
  dmvWebsite: "https://servicearizona.com/",
  dmvLabel: "ServiceArizona.com — AZ MVD",
  airports: [
    {
      code: "PHX",
      name: "Phoenix Sky Harbor International Airport",
      distance: "~15 miles southwest via Loop 101/I-10",
      address: "3400 E Sky Harbor Blvd, Phoenix, AZ 85034",
      note: "Primary commercial airport for Scottsdale travelers. Extensive nonstop international service to Mexico, Canada, Europe, and Asia.",
      flightUrl: "https://www.skyharbor.com/",
      flightLabel: "PHX Airport",
      featured: true,
    },
    {
      code: "SDL",
      name: "Scottsdale Airport",
      distance: "North Scottsdale — 9 miles from Old Town",
      address: "15000 N Airport Dr, Scottsdale, AZ 85260",
      note: "General aviation and private charter hub serving North Scottsdale executives and resort guests. No scheduled commercial service.",
      flightUrl: "https://www.scottsdaleaz.gov/airport",
      flightLabel: "SDL Airport",
      featured: false,
    },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Scottsdale Residents",
    intro: "Understanding how Scottsdale travelers actually move helps us anticipate the passport urgencies that arise here. From luxury resort guests to biotech executives to Barrett-Jackson collectors, Northeast Phoenix metro travel operates on a distinctive, high-demand rhythm.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PHX & Scottsdale Executive Air",
        subtitle: "Phoenix Sky Harbor, Scottsdale Airport (SDL)",
        description: "Phoenix Sky Harbor (PHX) is the primary commercial airport for Scottsdale travelers, about 15 miles southwest via the 101. PHX offers extensive nonstop international service to Mexico, Canada, Europe, and Asia. Scottsdale Airport (SDL) serves a large private aviation community — North Scottsdale residents, resort guests, and corporate travelers frequently bypass commercial terminals entirely. Many Scottsdale executives book international itineraries on short notice and discover expired passports only when consolidating travel documents.",
        tip: "Many countries require six months validity beyond your return date. Check your expiration before booking any international flights from PHX — especially for Mexico, Europe, and Asia-Pacific destinations popular with Scottsdale travelers.",
      },
      {
        icon: "ri-car-line",
        title: "Barrett-Jackson & Auction Travel",
        subtitle: "WestWorld of Scottsdale & international auctions",
        description: "The Barrett-Jackson Scottsdale Auction at WestWorld draws automotive collectors from across the globe — and many of those collectors travel to international auctions in Europe, the Middle East, and Asia throughout the year. Concours d'Elegance events in France, Germany, and Japan require current passports. Collector car dealers based in Scottsdale who import or export vehicles internationally often need their passport renewed or replaced quickly when deals close faster than expected.",
        tip: "International auction bids and collector car purchases can close quickly. Keep your passport current year-round if you participate in global automotive events — last-minute renewals are our specialty.",
      },
      {
        icon: "ri-heart-pulse-line",
        title: "Mayo Clinic & Medical Professional Travel",
        subtitle: "Mayo Clinic Scottsdale, HonorHealth, biotech corridor",
        description: "Mayo Clinic's Scottsdale campus is one of the most respected medical institutions in the American Southwest, attracting internationally recognized physicians, researchers, and specialists. These professionals travel frequently to international conferences, symposia, and collaborative research programs in Europe, Asia, and Latin America. Medical conference schedules are fixed — missing a presentation or symposium session has real career consequences that cannot be rescheduled.",
        tip: "Medical conferences and symposia have fixed schedules — your passport needs to be ready before the conference dates, not after. We regularly accommodate physicians on 5–7 day notice before major international medical meetings.",
      },
      {
        icon: "ri-building-4-line",
        title: "Scottsdale Financial & Resort Executives",
        subtitle: "SkySong, DC Ranch, Kierland corporate corridor",
        description: "Scottsdale hosts the regional headquarters of major financial services, insurance, real estate investment, and technology companies. Executives at State Farm's Scottsdale campus, Vanguard's Arizona operations, and the growing SkySong ASU Research Park travel internationally for client meetings, investment roadshows, and technology partnerships. North Scottsdale's luxury resort corridor adds hospitality executives managing international property portfolios who travel frequently to Europe and Asia.",
        tip: "Executives booking last-minute international travel through corporate travel desks sometimes discover passport issues at check-in. Start online with us as soon as you know your departure date — as fast as 24 hours in genuine emergencies.",
      },
    ],
    callout: {
      icon: "ri-sun-line",
      title: "Scottsdale Snowbird & Luxury Retiree Travel",
      description: "North Scottsdale attracts one of the most affluent retiree and snowbird populations in the United States — residents splitting time between Scottsdale estates and European river cruises, Mediterranean sailing itineraries, and African safari trips. Many are seasonal residents who last renewed their passport years ago. We handle expedited renewals for Scottsdale's luxury retirement community with the professional, low-friction service this demographic expects.",
    },
  },
  destinations: {
    title: "Where Scottsdale Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Northeast Phoenix metro clients. Understanding local travel behavior is part of why our document review catches issues before they derail your luxury resort trip, medical conference, or automotive auction.",
    stats: [
      { stat: "370+ mi", label: "to the LA Passport Agency from Scottsdale — we eliminate that trip" },
      { stat: "2–4 Wks", label: "average lead time when Scottsdale executives book international trips" },
      { stat: "$500K+", label: "median home value in the Scottsdale market — travelers who expect premium service" },
      { stat: "24 hrs", label: "fastest turnaround available for genuine Scottsdale emergency cases" },
    ],
    destinations: [
      {
        name: "Mexico (Cabo, Puerto Vallarta, Mexico City)",
        context: "Scottsdale residents book luxury resort trips to Los Cabos, Riviera Maya, and Mexico City on short notice — especially via PHX nonstops",
        urgency: "Last-minute luxury resort bookings happen 1–3 weeks out",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Italy & France",
        context: "European river cruises, Concours d'Elegance in France, fine art and wine tourism, and Mayo Clinic physician conference travel",
        urgency: "Medical conferences and auction events have fixed, non-negotiable dates",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Japan",
        context: "Barrett-Jackson collector auctions in Japan, automotive Concours events, corporate technology partnerships, and Mayo Clinic research collaborations",
        urgency: "Auction calendars and research symposia book 4–8 weeks in advance",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "United Kingdom",
        context: "Goodwood Revival and Festival of Speed, London financial meetings, and HonorHealth/Mayo Clinic physician CME programs",
        urgency: "Executive travel and collector event tickets are often booked 3–6 weeks ahead",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Canada",
        context: "Winter sports at Whistler and Banff, corporate mergers and acquisitions meetings in Toronto and Vancouver, NHL winter classics",
        urgency: "Winter peak bookings surge November through February",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Caribbean & Europe Cruises",
        context: "Scottsdale retirees and snowbirds book European river cruises and Caribbean sailings — and frequently discover passport issues within weeks of departure",
        urgency: "Retiree cruise bookings often occur 3–8 weeks before departure during promotional windows",
        icon: "ri-map-pin-2-line",
      },
    ],
    crossLinksTitle: "Explore Other Arizona Service Areas",
    crossLinksDesc: "We serve travelers across Arizona with the same expedited passport processing and document review expertise. Looking for service in another community?",
    crossLinks: [
      { name: "Phoenix", route: "/cities/phoenix" },
      { name: "Mesa", route: "/cities/mesa" },
      { name: "Tucson", route: "/cities/tucson" },
    ],
  },
};